/**
 * Data validation utilities for safe display of potentially invalid data
 */

export function safeDate(value: unknown): string {
  if (!value) return 'Unknown';
  const date = new Date(value as string | number | Date);
  return isNaN(date.getTime()) ? 'Invalid' : date.toLocaleString();
}

export function safeNumber(value: unknown, decimals = 0): number {
  const num = Number(value);
  return Number.isFinite(num) ? Number(parseFloat(num.toFixed(decimals))) : 0;
}

export function safeDuration(ms: unknown): string {
  const duration = safeNumber(ms);
  if (duration === 0) return '—';
  if (duration < 1000) return `${duration}ms`;
  return `${(duration / 1000).toFixed(1)}s`;
}

export function safePercent(value: unknown, decimals = 1): string {
  const num = safeNumber(value, decimals);
  return `${num}%`;
}

export function safeString(value: unknown, fallback = 'Unknown'): string {
  if (value === null || value === undefined) return fallback;
  return String(value);
}
